import { useFormikContext } from 'formik';
import useAdyen, { AdyenConfig } from '../../utils/useAdyen';

const adyenKlarnaKeys = {
  adyen_klarna_paynow: 'klarna_paynow',
  adyen_klarna_paylater: 'klarna',
  adyen_klarna_installments: 'klarna_account'
};

// https://docs.adyen.com/payment-methods/klarna/web-component
const AdyenKlarnaPayment = () => {
  const { values } = useFormikContext<{ paymentMethod: string }>();

  const name = adyenKlarnaKeys[values.paymentMethod];
  const adyenConfig: AdyenConfig = { payButton: 'base' };
  const AdyenKlarnaComponent = useAdyen({ name, adyenConfig, withActions: true });

  return AdyenKlarnaComponent;
};

export default AdyenKlarnaPayment;
